function versionUrl() {
  const base = process.env.BASE_URL || '/';
  const prefix = base.endsWith('/') ? base : `${base}/`;
  return `${prefix}version.json`;
}

let pending;

export function loadAppVersion() {
  if (!pending) {
    pending = fetch(versionUrl(), { cache: 'no-store' })
      .then((response) => (response.ok ? response.json() : {}))
      .catch(() => ({}))
      .then((data) => (data && typeof data === 'object' ? data : {}));
  }
  return pending;
}
